import { render, staticRenderFns } from "./ViewServer.vue?vue&type=template&id=43e60e00&"
import script from "./ViewServer.vue?vue&type=script&lang=ts&"
export * from "./ViewServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports